var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tokenGuid !== null)?_c('iframe',{staticStyle:{"width":"100%","height":"800px","border":"none"},attrs:{"src":'https://v4.biwee.fr/api/dashboard/' + _vm.tokenGuid,"scrolling":"no"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }